export default __webpack_public_path__ + "static/media/miguel-lopes-1.607be406.jpg";